/* eslint-disable jsx-a11y/html-has-lang */
import React, { FunctionComponent, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { onInitializeLottieJson } from "redux/actions/lottie-json.actions";
import { getLottieData } from "redux/selectors/lottie-json.selector";
import PshEoyView from "views/PshEoyView/PshEoyView";
import { createJsonData } from "helper/eoy-2022/createJsonData";
import { TEXT_VARIABLES_EOY_PSH_2022 } from "helper/eoy-2022/texts";
import EoyAnimation from "./video.json";

const PshEoy: FunctionComponent = () => {
  const { projectName, id }: { projectName: string; id: string } = useParams();
  const dispatch = useDispatch();
  const lottieData = useSelector(getLottieData());

  useEffect(() => {
    const data = createJsonData(projectName, id);
    const parsed = JSON.parse(data);
    dispatch(onInitializeLottieJson(EoyAnimation, parsed));
  }, [dispatch, id, projectName]);

  return lottieData.data ? (
    <PshEoyView
      jsonData={lottieData.data}
      name={TEXT_VARIABLES_EOY_PSH_2022[`${projectName}_${id}`].person}
    />
  ) : null;
};

export default PshEoy;
